import { organizerInvitedYou } from 'owa-locstrings/lib/strings/organizerinvitedyou.locstring.json';
import { youAreOrganizer } from 'owa-locstrings/lib/strings/youareorganizer.locstring.json';
import loc, { format } from 'owa-localize';
import { observer } from 'mobx-react-lite';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import { SenderImage, SenderPersonaWrapper } from 'owa-mail-sender-persona-view';
import Message from 'owa-service/lib/contract/Message';
import SingleRecipientType from 'owa-service/lib/contract/SingleRecipientType';

import * as React from 'react';

const styles = require('./CalendarDetailCard.scss');

export interface OrganizerDataRowProps {
    message: Message;
    organizer: SingleRecipientType;
    isOrganizer: boolean;
    isOldInvite: boolean;
}

const OrganizerDataRow = observer(function OrganizerDataRow(props: OrganizerDataRowProps) {
    let { organizer, isOrganizer, message, isOldInvite } = props;
    let organizerText = isOrganizer ? loc(youAreOrganizer) : format(loc(organizerInvitedYou), ' ');

    return (
        <div className={styles.organizerRow}>
            <SenderImage
                sender={organizer}
                displaySelf={false}
                style={styles.senderImage}
                size={PersonaSize.extraExtraSmall}
            />
            <div className={styles.organizerText}>
                {!isOrganizer && (
                    <SenderPersonaWrapper
                        message={message}
                        treatAsDraft={false}
                        isNodePending={false}
                        senderPersonaClassName={isOldInvite ? styles.oldInvite : ''}
                    />
                )}
                <span>{organizerText}</span>
            </div>
        </div>
    );
});
export default OrganizerDataRow;
